import { Edit, SimpleForm, useGetIdentity, useGetOne, useNotify, useRedirect, useTranslate } from 'react-admin'
import Form from '../../inputFormComponents/Form'
import { apiService } from '../../apiService'
import { AddTextModelEmailCommand, RemoveTextModelEmailCommand, UserReadModel } from '../../GeneratedClients/FreeBillApi'
import { useMutation } from "react-query";
import MailTextEditActions from './MailTextEditActions';
import MailTextToolBar from './MailTextToolBar';
import FormCardTextModelEmail from '../../textModel/FormCardTextModelEmail';
import textModelEmailTemplate from '../../fixtures/textModelEmailTemplate';
import DescriptionUserEmailText from '../form/descriptions/DescriptionUserEmailText';

const MailTextEdit = () => {

  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})
  const { mutate: addTextModel } = useMutation((command: AddTextModelEmailCommand) => 
    apiService.UsersApi.addTextModelEmail({addTextModelEmailCommand: command, id: identity!.id.toString()})  
  )
  const { mutate: removeTextModel } = useMutation((command: RemoveTextModelEmailCommand) => 
    apiService.UsersApi.removeTextModelEmail({removeTextModelEmailCommand: command, id: identity!.id.toString()})  
  )

  const handleSubmit = async(fieldValues: UserReadModel) => {
    fieldValues.textModelEmail ? (
      addTextModel({userId: fieldValues.id, textModelEmail: fieldValues.textModelEmail}, {
        onSuccess() {
          notify(translate('ra.notification.updated', {smart_count: 1}))
          redirect(`/users/${fieldValues.id}/mailServiceConfig/1`)
        },
        onError(error: any) {
          notify(error, {type: 'error'})
        },  
      })
    ) : (
      removeTextModel({userId: fieldValues.id}, {
        onSuccess() {
          notify(translate('ra.notification.deleted', {smart_count: 1}))
          redirect(`/users/${fieldValues.id}/mailServiceConfig/1`)
        },
        onError(error: any) {
          notify(error, {type: 'error'})
        },  
      })
    )
  }

  if(isLoading || userLoading || !identity) return null

  const textModelEmail = user?.textModelEmail ? user.textModelEmail : textModelEmailTemplate
  const configTextModel = user?.textModelEmail ? "show" : "hide"

  const cards = [<FormCardTextModelEmail 
    initConfigTextModelEmail={configTextModel} 
    textModelEmail={textModelEmail}  
    description={<DescriptionUserEmailText />}
  />]

  return (
    <Edit 
      resource='users' 
      id={identity.id} 
      actions={<MailTextEditActions />}
      title={translate("resources.textTemplates.name", {smart_count: 2})}
    >
      <SimpleForm 
        onSubmit={handleSubmit} 
        toolbar={<MailTextToolBar />}
        defaultValues={{id: identity.id, configTextModel: configTextModel, textModelEmail: textModelEmail}}
      >
        <Form 
          cards={cards} 
        />
      </SimpleForm>
    </Edit>
  )
}

export default MailTextEdit